// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1DayPropertySchema } from './v1/dayPropertySchema';
import { v1UnauthorizedErrorSchema } from './v1/unauthorizedErrorSchema';

export const listDayPropertiesPathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID"),
});

export const listDayPropertiesQueryParamsSchema = z.object({
  since: z.optional(z.string().date().describe("Start date for filtering (YYYY-MM-DD)")),
  until: z.optional(z.string().date().describe("End date for filtering (YYYY-MM-DD)")),
  dates: z.optional(z.coerce.string().describe("Comma-separated list of specific dates (YYYY-MM-DD)")),
}).optional();

export const listDayPropertiesHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description Day properties retrieved successfully
 */
export const listDayProperties200Schema = z.array(z.lazy(() => v1DayPropertySchema));

/**
 * @description Unauthorized
 */
export const listDayProperties401Schema = z.lazy(() => v1UnauthorizedErrorSchema);

export const listDayPropertiesQueryResponseSchema = z.lazy(() => listDayProperties200Schema);
